import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface PicflowMaintenanceService {
  /** Emits `undefined` when the feature flags couldn't be loaded in time. */
  getRealTimeMaintenanceMode: () => Observable<boolean | undefined>;
}

export const PICFLOW_MAINTENANCE = new InjectionToken<PicflowMaintenanceService>('PicflowMaintenanceService');
